// src/components/kuestion/student/StudentTopbar.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useStudentAuth } from '../../../context/StudentAuthContext';
import AccountMenu from '../shared/AccountMenu';
import AppNoticeboard from '../shared/AppNoticeboard';
import { Mark } from '../shared/Bits';
import { BookIcon } from '../shared/Icons';
import { kq } from '../../../config/routes';

export default function StudentTopbar({ strong, children }) {
  const navigate = useNavigate();
  const { student, logout } = useStudentAuth();
  return (
    <header className={`kqc-topbar${strong ? ' kqc-topbar--strong' : ''}`}>
      <span className="kqc-topbar__mark"><Mark /></span>
      <span className="kqc-topbar__brand">Kuestion</span>
      {student?.org_display_name && <span className="kqc-topbar__sub">{student.org_display_name}</span>}
      <span className="kqc-spacer" />
      {children}
      <AppNoticeboard />
      <a className="kqc-iconbtn" href={kq('kb')} target="_blank" rel="noopener noreferrer" title="Knowledge base — opens in a new tab" aria-label="Knowledge base (opens in a new tab)"><BookIcon /></a>
      <AccountMenu
        name={student?.first_name ? `${student.first_name}${student.last_name ? ` ${student.last_name}` : ''}` : (student?.login_id || 'Student')}
        role={student?.login_id || 'Student'}
        initial={(student?.first_name || student?.login_id || 'S')[0].toUpperCase()}
        onLogout={() => { logout(); navigate(kq('login')); }}
        note="Every deadline you see is shown in this zone, named. Your school sets the default; you can choose your own."
      />
    </header>
  );
}
